import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { func } from "prop-types";
import { actions as echeckActions } from "reducers/echecks";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";

const FORM_ID = "echeck";

class AnulateCesionEcheq extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
    };

    render() {
        const { handleSubmit } = this.props;

        return (
            <div className="container">
                <I18n id="echeck.anulate.cesion.reason" component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={TextField}
                        name="anulate"
                        maxLength={99}
                        type="text"
                        hideLabel
                        hidePlaceholder
                        idForm={FORM_ID}
                    />
                    <Button type="submit" className="btn-primary" label="global.add" />
                </Form>
            </div>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({ anulate: "" }),
        validationSchema: () =>
            Yup.object().shape({
                anulate: Yup.string().required(i18n.get("global.error.required")),
            }),
        handleSubmit: (filters, formikBag) => {
            const { dispatch } = formikBag.props;
            dispatch(echeckActions.setEcheqsSpecialAttribute(filters.anulate));
            dispatch(echeckActions.echeqCesionData({}));
            dispatch(push("/echecks/action/cesion/confirm"));
        },
    }),
)(AnulateCesionEcheq);
